<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";
  import emailjs from "@emailjs/browser";
  
  let Begining =
    "Craft2Code was founded to bring businesses innovative digital solutions, combining technical expertise with client-focused service. Since our inception, we have been helping companies succeed through web, mobile, software, and blockchain development.";
  let Mission =
    "We aim to empower businesses with scalable, reliable, and cutting-edge digital solutions, providing dedicated support and expertise at every stage of development.";
  let Global =
    "Our team collaborates with clients worldwide, delivering innovative solutions tailored to diverse industries and business goals.";
  let Whyus =
    "We build strong partnerships by understanding client challenges and delivering high-quality, results-driven solutions. Our focus is on creating reliable, efficient, and user-centered digital experiences.";
  let contactinformation = {};

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  // Function to start the animation on mount
  function startAnimation() {
    const progressBars = document.querySelectorAll(".progress-bar .progress");
    progressBars.forEach((bar) => {
      bar.classList.add("animate");
    });
  }
  function fillForm() {
    const nameInput = document.getElementById("name");
    const emailInput = document.getElementById("company");
    const messageInput = document.getElementById("email");

    if (nameInput && emailInput && messageInput) {
      // Replace these values with the desired values
      nameInput.value = "John Doe";
      emailInput.value = "example@example.com";
      messageInput.value = "This is a test message.";
    } else {
      console.error("One or more form elements not found.");
    }
  }

  // Run the animation on mount
  window.addEventListener("scroll", function () {
    const scrollingImage = document.getElementById("scrollingImage");
    scrollingImage.style.top = `${window.scrollY * 0.06}px`; // Adjust the scroll speed as needed
  });

  window.addEventListener("scroll", function () {
    const verticalLine = document.querySelector(".vertical-line");
    const ball = document.querySelector(".ball");

    const lineBottom = verticalLine.getBoundingClientRect().bottom;

    if (lineBottom < 0) {
      ball.style.display = "none";
    } else {
      ball.style.display = "block";
    }

    ball.style.top = `${window.scrollY * 0.78}px`;
  });
  let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
    startAnimation();
    window.addEventListener("scroll", handleScroll);

    const interval = setInterval(updateImages, 5000);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(interval);
    };
  });
  function handleScroll() {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop;
    const element = document.getElementById("footerImage");
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // Calculate the distance scrolled since the last scroll event
    const scrollDistance = currentScrollPos - prevScrollPos;

    // Calculate the scaling factor based on the scroll direction
    const scaleIncrement = scrollDistance > 0 ? 0.001 : -0.001; // Adjust the scale increment

    // Adjust the scale of the image
    const currentScale =
      parseFloat(
        element.style.transform.replace("scale(", "").replace(")", "")
      ) || 1;
    const newScale = Math.max(
      0.5,
      Math.min(1, currentScale + scaleIncrement) // Adjust the maximum scale
    );

    // Update the scale of the image
    element.style.transform = `scale(${newScale})`;

    // Update previous scroll position
    prevScrollPos = currentScrollPos;
  }

  let images = [
    "/img/logo1.png",
    "/img/logo2.png",
    "/img/logo3.png",
    "/img/logo4.png",
    "/img/logo5.png",
    "/img/logo6.png",
    "/img/logo1.png", // Repeated images for smooth looping
    "/img/logo2.png",
    "/img/logo3.png",
    "/img/logo4.png",
    "/img/logo5.png",
    "/img/logo6.png",
  ];

  let index = 0;
  let visibleImages = images.slice(0, 5);

  function updateImages() {
    index = (index + 1) % images.length;
    visibleImages = images.slice(index, index + 5);
    if (visibleImages.length < 5) {
      visibleImages = [
        ...visibleImages,
        ...images.slice(0, 5 - visibleImages.length),
      ];
    }
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="pagewrap">
  <div class="contenthod">
    <h1>About Us</h1>
    <p class="large-text">Dedicated to Delivering Excellence in Digital Development</p>
  </div>
  <div class="vertical-line">
    <div class="ball"></div>
  </div>
</div>

<div class="container">
  <div class="frame">
    <div class="background"></div>
    <div class="imgcontainer">
      <div class="purple"></div>
      <img class="purple2" src="/img/7.jpg" alt="maskgrp" />
    </div>
  </div>
  <div class="descriptionr">
    <p>Our Beginning</p>
    <div class="text">{Begining}</div>
  </div>
</div>

<div class="container">
  <div class="description">
    <p>Our Mission</p>
    <div class="text">{Mission}</div>
  </div>
  <div class="framer">
    <div class="background"></div>
    <div class="imgcontainer">
      <div class="purple"></div>
      <img class="purple2" src="/img/8.jpg" alt="vision" />
    </div>
  </div>
</div>

<div class="container">
  <div class="frame">
    <div class="background"></div>
    <div class="imgcontainer">
      <div class="purple"></div>
      <img class="purple2" src="/img/9.jpg" alt="vision" />
    </div>
  </div>
  <div class="descriptionr">
    <p>Global Expertise</p>
    <div class="text">{Global}</div>
  </div>
</div>

<div class="container4">
  <div class="description12">
    <p>Why Us</p>
    <div class="text">{Whyus}</div>
    <button class="learn-more">Learn More</button>
  </div>
</div>

<div class="ho3">
  <div class="content">
    <p class="top-left-text">OUR CORE VALUES</p>
    <p class="bottom-left-text">
      Our culture is built around four key<br />attributes that drive everything<br />we do.
    </p>
  </div>
  <div class="right23">
    <img src="/img/logo12.png" alt="Image" />
  </div>
</div>
<div class="card-container1">
  <div class="card1">
    <i class="fas fa-star"></i>
    <h2>Passionate</h2>
    <p>We are enthusiastic about delivering exceptional results.</p>
  </div>
  <div class="card1">
    <i class="fas fa-crown"></i>
    <h2>Respectful</h2>
    <p>We treat clients and colleagues with professionalism and courtesy.</p>
  </div>
  <div class="card1">
    <i class="fas fa-medal"></i>
    <h2>Ownership</h2>
    <p>We take responsibility for our work and its impact.</p>
  </div>
  <div class="card1">
    <i class="fas fa-brain"></i>
    <h2>Unified</h2>
    <p>
      We collaborate as a team to ensure seamless project execution.
    </p>
  </div>
</div>


<!-- <div class="slideshow-container">
  <div class="slideshow-images">
    {#each visibleImages as img}
      <img src={img} alt="Slideshow Image" />
    {/each}
  </div>
</div> -->

<div class="logo">
  <div class="leftlo">
    <h2>Client-Focused Approach</h2>
    <p style="color: #333333;">
      We prioritize clear communication, efficient workflows, and solutions
      designed to achieve measurable business results. Every project is
      approached with precision, creativity, and a commitment to excellence.
    </p>
    <button class="button" on:click={() => document.getElementById('consultation-form').scrollIntoView({ behavior: 'smooth' })}>Get in touch</button>
  </div>
  <div class="rightlo">
    <img src="/img/10.jpg" alt="Your Image Description" />
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container" id="consultation-form">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay">
          <h2><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <span style="color: black; font-size: 24px;">CLUTCH</span>
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  body {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* css for footer */

  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }


  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transform: scale(0.7);
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }

  /* Page wrapper */
  .pagewrap {
    background-color: #ffffff;
    padding: 5px 0;
    display: flex;
    justify-content: center; /* Center the content horizontally */
    align-items: center; /* Center the content vertically */
    height: 50vh; /* Make the wrapper full height */
    text-align: center; /* Center the text */
    position: relative; /* Position the line and ball relative to the page wrapper */
  }

  /* Content holder */
  .contenthod h1 {
    font-family: BreeSerif;
    color: #333333;
  }

  .contenthod h1 {
    font-size: 65px; /* Larger font size for "About Us" */
    margin-bottom: 20px;
  }

  .contenthod p.large-text {
    font-size: 2rem; /* Larger font size for "Dedicated to delivering excellence" */
    margin-bottom: 10px;
  }

  .contenthod p {
    font-size: 1rem; /* Normal small size for the rest */
    margin: 0;
    line-height: 1.4;
  }

  /* Vertical line */
  .vertical-line {
    position: absolute;
    top: calc(
      100% + 30px
    ); /* Adjust this value to create space between the text and the line */
    bottom: 0;
    left: 50%; /* Center the line horizontally */
    transform: translateX(-50%);
    width: 2px; /* Width of the vertical line */
    height: calc(
      350%
    ); /* Make the line extend from below the text to the bottom of the page */
    background-color: #000000; /* Color of the line */
  }
  /* Ball */
  .ball {
    position: fixed;
    top: calc(
      100% - 70px
    ); /* Adjust the position to leave some space before the bottom of the viewport */
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background-color: #000000;
    border-radius: 50%;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: right;
    height: 70%;
    margin-top: 20px;
    width: 100%;
  }
  .description {
    width: 45%; /* Adjust the max-width as needed */
    /* margin-left: auto; */
    /* margin-right: auto; */
    margin-top: 90px;
    margin-left: 70px;
  }
  .descriptionr {
    width: 45%; /* Adjust the max-width as needed */
    margin-top: 90px;
  }

  .frame {
    display: flex;
    flex-direction: column;
    align-items: right;
    margin-right: 200px;
    width: 50%;
    margin-left: 0px;
  }
  .framer {
    display: flex;
    flex-direction: column;
    align-items: right;
    margin-left: 200px;
    width: 50%;
    margin-right: 0px;
  }

  .imgcontainer {
    position: relative;
    width: 100%; /* Adjust the width as needed */
    margin-bottom: 10px;
    height: 400px; /* Adjust the height as needed */
  }

  .imgcontainer img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .description p {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333333;
    font-family: BreeSerif;
    font-size: 65px;
  }
  .descriptionr p {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333333;
    font-family: BreeSerif;
    font-size: 65px;
  }
  .container4 {
    display: flex;
    justify-content: center; /* Center the content horizontally */
  }

  .description12 {
    width: 80%;
    text-align: left; /* Align text to the left */
    margin: 0 auto; /* Center the description horizontally */
  }

  .description12 p {
    display: inline-block; /* Make the background apply only to the text */

    padding: 5px; /* Add padding for spacing */
    font-weight: bold;
    top: 0;
    text-align: center;
    margin-left: 30px;
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 10px;
    font-size: 65px; /* Increase font size */
    line-height: 1.6; /* Increase line spacing */
  }

  .description12 .text {
    margin-bottom: 20px; /* Add margin bottom for spacing */
    font-size: 1.25rem; /* Increase font size */
    line-height: 1.6; /* Increase line spacing */
    left: 20px;
    margin-left: 30px;
    color: #333333;
    font-family: SourceSans;
  }

  .description12 .learn-more {
    margin-left: 30px;
    color: #054f76;
    border: none; /* Remove border */
    background: none; /* Remove background */
    cursor: pointer; /* Add cursor pointer on hover */
    font-size: 1.25rem; /* Increase font size */
  }
  .description12 .learn-more:hover {
    color: #dc1f26; /* Set text color to blue */
  }

  .description .text {
    margin-bottom: 10px;
  }

  .ho3 {
    background: rgb(58, 58, 58); /* Background color gray */
    height: 300px; /* Increased height for better spacing */
    position: relative;
    padding-top: 80px;
    margin-top: 50px;
    max-width: 100%;
    display: flex;
    border-radius: 5px;
  }

  .content {
    width: 50%;
    color: rgb(233, 228, 228);
    padding: 20px;
  }

  .right23 {
    width: 50%;
    position: relative;
  }

  .right23 img {
    width: 300px; /* Adjust the width of the image */
    height: 70%; /* Maintain aspect ratio */
    transform: scale(1); /* Increase the scale of the image */
  }

  #scrollingImage {
    position: absolute;
    top: 80%;
    right: 35%; /* Align image to the right */
    transform: translateY(-50%);
    max-width: 100%;
  }

  .top-left-text {
    font-size: 10px;
    background-color: rgb(37, 37, 37);
    position: absolute;
    border-radius: 5px;
    font-family: SourceSans;
    top: 20px; /* Adjust top position */
    left: 20px; /* Adjust left position */
    padding: 10px; /* Add padding */
    margin-bottom: 30px;
  }

  .bottom-left-text {
    font-size: 45px;
    border-radius: 10px;
    font-family: BreeSerif;
    /* font-weight: bold; */
    position: absolute;
    top: 70px; /* Below the top-left-text with spacing */
    left: 20px; /* Adjust left position */
  }
  .card-container1 {
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
  }

  .card1 {
    width: 20%; /* Adjusted width */
    height: 300px; /* Adjusted height */
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    align-items: center; /* Center content horizontally */
    justify-content: center; /* Center content vertically */
  }

  .card1 i {
    font-size: 60px; /* Increased font size */

    color: black;
    margin-bottom: 10px; /* Adjusted margin bottom */
  }
  .card1 i:hover {
    color: #dc1f26;
  }

  .card1 h2 {
    text-align: center; /* Center the text */
    font-size: 1.5rem; /* Adjusted font size */
    margin: 5px 0; /* Decreased margin */
  }

  .card1 p {
    text-align: center; /* Center the text */
    font-size: 1rem; /* Adjusted font size */
    margin: 5px 0; /* Decreased margin */
  }

  .job-section {
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #dc1f26, #ffffff); */
    color: white;
    padding: 0px 0px;
    text-align: center;
  }

  .job-content {
    max-width: 800px;
    margin: 0 auto;
  }

  .job-content h2 {
    font-size: 65px; /* Larger font size for the title */
    margin-bottom: 20px; /* Reduce margin */
    font-weight: bold; /* Make the title bold */
    color: #333333; /* Dark blue color */
    font-family: BreeSerif;
  }

  .job-content p {
    font-size: 1.15rem; /* Smaller font size for the description */
    margin-bottom: 40px;
    font-weight: normal; /* Ensure the description is not bold */
    color: #333333; /* Dark blue color */
    font-family: SourceSans;
  }

  .job-btn {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .job-btn::before,
  .job-btn::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .job-btn::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .job-btn::after {
    right: 50%;
    transform: translateX(50%);
  }

  .job-btn:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .job-btn:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .job-btn:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .logo {
    margin-top: 40px;
    margin-bottom: 50px;
    display: flex;
    background-color: white;
    width: 100%;
    align-items: center;
  }

  .leftlo p {
    font-size: 1.2rem;
    font-family: SourceSans;
  }

  .leftlo h2 {
    font-size: 60px;
    color: #333333;
    font-family: BreeSerif;
  }

  .leftlo {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items horizontally */
    justify-content: center; /* Center items vertically */
  }

  .rightlo {
    display: flex;
    flex-direction: column; /* Display images in a column */
    width: 50%;
    padding: 20px; /* Adjust padding as needed */
    box-sizing: border-box; /* Include padding in width */
    height: 100%;
  }

  .rightlo img {
    max-height: 500px; /* Set the maximum height */
    width: auto; /* Maintain aspect ratio */
    object-fit: contain; /* Ensure the image is contained within the specified height */
  }

  .button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .button::before,
  .button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  @media (min-width: 769px) and (max-width: 1024px) {
    .pagewrap {
      margin-top: 2%;
      padding-top: 0px;
      height: auto;
    }
    .contenthod h1 {
      font-size: 3rem; /* Adjust font size for tablets */
      margin-top: 8%;
      padding-top: 0px;
    }

    .contenthod p.large-text {
      font-size: 2rem; /* Adjust font size for tablets */
    }

    .vertical-line {
      display: none; /* Hide the vertical line on tablets */
    }

    .container {
      flex-direction: column;
      align-items: center;
      height: auto;
    }

    .description,
    .descriptionr,
    .frame,
    .framer {
      width: 100%;
      margin: 10px 0;
    }

    .frame {
      margin-right: 0;
      margin-left: 0;
    }

    .framer {
      margin-left: 0;
      margin-right: 0;
    }

    .description p,
    .descriptionr p {
      font-size: 3rem; /* Adjust font size for tablets */
    }

    .imgcontainer {
      height: auto; /* Adjust height for tablets */
    }
    .description12 p {
      font-size: 3rem; /* Adjust font size for tablets */
      margin-left: 20px; /* Adjust margin for tablets */
    }

    .description12 .text {
      font-size: 1.25rem; /* Adjust font size for tablets */
      margin-left: 20px; /* Adjust margin for tablets */
    }

    .description12 .learn-more {
      font-size: 1.25rem; /* Adjust font size for tablets */
      margin-left: 20px; /* Adjust margin for tablets */
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      padding: 0px;
    }

    .content,
    .right23 {
      width: 100%;
      text-align: center;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .top-left-text {
      position: static;
      font-size: 1.5rem; /* Adjust font size for tablets */
      display: block;
      margin: 10px 0;
    }

    .bottom-left-text {
      position: static;
      font-size: 2rem; /* Adjust font size for tablets */
      display: block;
      margin: 10px 0;
    }

    .right23 img {
      position: static;
      width: 100%;
      height: auto; /* Adjust height for tablets */
      transform: none; /* Remove scaling */
      margin-top: 20px;
      display: none;
    }

    #scrollingImage {
      position: static;
      transform: none; /* Remove translate */
      margin: 0 auto; /* Center the image */
    }
    .card1 {
      width: 45%; /* Adjust width for tablets */
      height: auto; /* Adjust height for content */
    }

    .card1 i {
      font-size: 50px; /* Adjust font size for tablets */
    }

    .card1 h2 {
      font-size: 1.375rem; /* Adjust font size for tablets */
    }

    .card1 p {
      font-size: 1rem; /* Adjust font size for tablets */
    }
    .logo {
      flex-direction: column;
      padding: 0px;
    }

    .rightlo {
      width: 100%;
      padding: 0; /* Adjust padding for tablet view */
      text-align: center; /* Center image on tablets */
    }

    .rightlo img {
      max-height: 400px; /* Adjust max-height for tablet view */
      width: 100%;
      object-fit: cover; /* Cover to maintain aspect ratio */
    }

    .leftlo {
      align-items: center; /* Center items horizontally */
      text-align: center; /* Center text on tablets */
    }

    .leftlo h2 {
      font-size: 3rem; /* Adjust font size for tablets */
    }

    .leftlo p {
      font-size: 1.1rem; /* Adjust font size for tablets */
    }

    .button {
      font-size: 1.1rem; /* Adjust button font size for tablets */
      padding: 12px 22px; /* Adjust button padding for tablets */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }
    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }
  @media (min-width: 480px) and (max-width: 769px) {
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
        }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
    .pagewrap {
      flex-direction: column;
      height: auto;
      margin-top: 5%;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .contenthod h1 {
      font-size: 2rem; /* Smaller font size for mobile */
    }

    .contenthod p.large-text {
      font-size: 1.5rem; /* Adjust font size for mobile */
    }

    .vertical-line {
      display: none; /* Hide the vertical line on mobile */
    }

    .container {
      flex-direction: column;
      align-items: center;
      height: auto;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .description,
    .descriptionr,
    .frame,
    .framer {
      width: 90%;
      margin: 10px 0;
    }

    .frame {
      margin-right: 0;
      margin-left: 0;
    }

    .framer {
      margin-left: 0;
      margin-right: 0;
    }

    .description p,
    .descriptionr p {
      font-size: 2rem; /* Adjust font size for mobile */
    }

    .imgcontainer {
      height: auto; /* Adjust height for mobile */
    }
    .imgcontainer {
      text-align: left;
      width: 100%;
      left: 0%;
    }
    .framer .imgcontainer {
      text-align: left;
      left: 0%;
      width: 100%;
    }
    .vertical-line {
      display: none;
    }

    .ball {
      display: none;
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      padding: 0px;
    }

    .content,
    .right23 {
      width: 100%;
      text-align: center;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .top-left-text {
      position: static;
      font-size: 1rem; /* Adjust font size for mobile */
      display: block;
      margin: 10px 0;
    }

    .bottom-left-text {
      position: static;
      font-size: 1.5rem; /* Adjust font size for mobile */
      display: block;
      margin: 10px 0;
    }

    .right23 img {
      position: static;
      width: 100%;
      height: auto; /* Adjust height for mobile */
      transform: none; /* Remove scaling */
      margin-top: 20px;
      display: none;
    }

    #scrollingImage {
      position: static;
      transform: none; /* Remove translate */
      margin: 0 auto; /* Center the image */
    }
    .card-container1 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 0;
    }

    .card1 {
      width: 40%; /* Two cards side by side on mobile */
      margin-bottom: 10px; /* Space between rows */
      height: auto;
    }

    .card1 i {
      font-size: 40px; /* Adjust font size for mobile */
    }

    .card1 h2 {
      font-size: 1.25rem; /* Adjust font size for mobile */
    }

    .card1 p {
      font-size: 0.875rem; /* Adjust font size for mobile */
    }
    .logo {
      flex-direction: column;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .rightlo {
      width: 100%;
      padding: 0; /* Remove padding for better fit on small screens */
    }

    .leftlo h2 {
      font-size: 2rem; /* Adjust font size for small screens */
    }

    .leftlo p {
      font-size: 1rem; /* Adjust font size for small screens */
    }

    .rightlo img {
      max-height: 300px; /* Adjust the max-height for small screens */
      width: 100%; /* Ensure full width */
      object-fit: cover; /* Cover to maintain aspect ratio */
    }

    .button {
      font-size: 1rem; /* Adjust button font size for small screens */
      padding: 10px 20px; /* Adjust button padding for small screens */
    }

    .container4 {
      flex-direction: column;
      text-align: center;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }
    .description12 p {
      font-size: 2rem; /* Adjust font size for mobile */
      margin-left: 10px; /* Adjust margin for mobile */
    }

    .description12 .text {
      font-size: 1rem; /* Adjust font size for mobile */
      margin-left: 10px; /* Adjust margin for mobile */
    }

    .description12 .learn-more {
      font-size: 1rem; /* Adjust font size for mobile */
      margin-left: 10px; /* Adjust margin for mobile */
    }
  }

  @media (max-width: 480px) {
    .job-content h2 {
      font-size: 45px;
    }
    .contenthod h1 {
      font-size: 2rem; /* Smaller font size for mobile */
    }

    .contenthod p.large-text {
      font-size: 1.5rem; /* Adjust font size for mobile */
    }
    .container {
      flex-direction: column;
      /* align-items: center; */
      height: auto;
      padding: 0px;
      padding-top: 0px;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }
    .imgcontainer {
      text-align: left;
      width: 100%;
      left: 0%;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
      margin-bottom: 0px;
      margin-top: 10px;
    }
    .framer {
      align-items: left;
      text-align: left;
      width: 100%;
      left: 0%;
      margin-left: 0px;
      padding-left: 0px;
      padding-top: 0px;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }
    .framer .imgcontainer {
      text-align: left;
      left: 0%;

      width: 100%;
    }
    .container4 {
      flex-direction: column;
      text-align: left;
      padding: 0px;
    }

    .description,
    .descriptionr,
    .description12 {
      margin: 0px 0;
      margin-top: 0px;
      padding-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
      width: 90%;
    }
    .description p,
    .descriptionr p {
      margin-top: 0px;
      padding-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
      font-size: 45px;
    }
    .frame,
    .framer {
      width: 100%;
      margin-right: 0;
      margin-left: 0;
      padding-top: 0px;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }

    .pagewrap {
      /* padding: 20px; */
      flex-direction: column;
      height: auto;
      margin-top: 9%;
    }

    .vertical-line {
      display: none;
    }

    .ball {
      display: none;
    }

    .learn-more {
      width: 100%;
      padding: 10px;
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      margin-left: 0px;
      width: 100%;
      margin-right: 0px;
    }

    .content,
    .right23 {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      padding-top: 0px;
      margin-top: 0px;
      text-align: center;
    }

    .top-left-text {
      position: static;
      font-size: 1rem; /* Adjust font size for mobile */
      display: block;
      margin: 0px 0;
      margin-left: 0px;
      margin-right: 0px;
    }

    .bottom-left-text {
      position: static;
      font-size: 1.5rem; /* Adjust font size for mobile */
      display: block;
      margin: 10px 0;
      margin-left: 0px;
      margin-right: 0px;
    }

    .right23 img {
      position: static;
      width: 100%;
      height: auto; /* Adjust height for mobile */
      transform: none; /* Remove scaling */
      margin-top: 20px;
      display: none;
    }

    .card-container1 {
      display: flex;
      flex-wrap: wrap;
      /* justify-content: space-between; */
      margin: 0 0;
    }

    .card1 {
      height: auto;
      width: 30%; /* Two cards side by side on mobile */
      margin-bottom: 0px; /* Space between rows */
      margin-top: 30px;
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .card1 i {
      font-size: 40px; /* Adjust font size for mobile */
    }

    .card1 h2 {
      font-size: 1.25rem; /* Adjust font size for mobile */
    }

    .card1 p {
      font-size: 0.875rem; /* Adjust font size for mobile */
    }
    .logo {
      flex-direction: column;
    }

    .rightlo {
      width: 100%;
      padding: 0; /* Remove padding for better fit on small screens */
    }

    .leftlo h2 {
      font-size: 2rem; /* Adjust font size for small screens */
    }

    .leftlo p {
      font-size: 1rem; /* Adjust font size for small screens */
    }

    .rightlo img {
      max-height: 300px; /* Adjust the max-height for small screens */
      width: 100%; /* Ensure full width */
      object-fit: cover; /* Cover to maintain aspect ratio */
    }

    .button {
      font-size: 1rem; /* Adjust button font size for small screens */
      padding: 10px 20px; /* Adjust button padding for small screens */
    }

    .container4 {
      flex-direction: column;
      text-align: center;
    }
    .description12 p {
      font-size: 45px; /* Adjust font size for mobile */
      margin-left: 10px; /* Adjust margin for mobile */
    }

    .description12 .text {
      font-size: 1rem; /* Adjust font size for mobile */
      margin-left: 10px; /* Adjust margin for mobile */
    }

    .description12 .learn-more {
      font-size: 1rem; /* Adjust font size for mobile */
      margin-left: 10px; /* Adjust margin for mobile */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
        }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
      margin-top: 0px;
      padding-top: 10px;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 0px;
      padding-top: 0px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
      margin-top: 0px;
      padding-top: 0px;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
  }

  @media (max-width: 350px) {
    .container {
      padding: 10px;
    }

    .container4,
    .ho3 {
      padding: 10px;
    }

    .description,
    .descriptionr,
    .description12 {
      padding: 5px;
    }

    /* .pagewrap {
      padding: 10px;
    } */

    .learn-more {
      padding: 8px;
    }
  }
</style>
